import { createFileRoute } from '@tanstack/react-router'
import EditionTeam from 'Edition/components/sections/Team/EditionTeam'

export const Route = createFileRoute('/work/$workId_/edition/$editionId/team')({
    component: EditionTeam,
})
